import { watchScroll } from './lib/scroll';
import { setupModalVideo } from './lib/video';
import { setupTobCourses } from './lib/tob-campus';
import { setupAnimations } from './lib/animate';
import { mount as mountGlideSliders } from '../../wp-content/themes/usdigital-child/blocks/src/glide-slider/client';

/**
 * Bootstrap 5 JS
 */
const bootstrap = require('bootstrap');
window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', (e) => {
	// do stuff...
	/**
	 * Update [data-scroll] on html element
	 */
	watchScroll();
	/**
	 * Handle modal close, add click listeners to video
	 * buttons.
	 */
	setupModalVideo();
	/**
	 * Find and mount glide sliders
	 */
	mountGlideSliders();
	/**
	 * Setup TOB Courses
	 */
	setupTobCourses();
	/**
	 * Setup Animations
	 */
	 setupAnimations();
});
